export const ERROR_TYPES = Object.freeze({
  NOT_FOUND: 'not_found',
});
